import { render, staticRenderFns } from "./EsqueceSenha.vue?vue&type=template&id=6acdd182&scoped=true&"
import script from "./EsqueceSenha.vue?vue&type=script&lang=js&"
export * from "./EsqueceSenha.vue?vue&type=script&lang=js&"
import style0 from "./EsqueceSenha.vue?vue&type=style&index=0&id=6acdd182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acdd182",
  null
  
)

export default component.exports